import { useSuspenseQuery } from '@tanstack/react-query';
import { DaysOfWeekOptions, getAgencySettingsOptions, editGeneralAgencySettingsOptions } from '@generated';
import Yup from '~/util/yup';
import { SelectFormField } from '~/shared/forms/controls/fields/SelectFormField';
import { TextFormField } from '~/shared/forms/controls/fields/text-fields/TextFormField';
import { FileText } from 'lucide-react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibraryForm } from '../shared/LibraryForm';
import { AddressFormField } from '~/shared/forms/controls/fields/AddressFormField';

export const MedicareAgencySettingsSection = {
	settingsView: 'medicare',
	title: 'Medicare Settings',
	description: 'Configure Medicare-specific billing and compliance settings',
	TitleIcon: FileText
} satisfies SettingsSectionItem;

const validationSchema = Yup.object().shape({
	agencyStartOfWeek: Yup.string().label('Start of Week').nullable().required(),
	cmsCertificationNumber: Yup.string().label('CMS Certification Number').nullable()
});

export function MedicareAgencySettingsForm() {
	const { data: settings } = useSuspenseQuery(getAgencySettingsOptions());

	return (
		<LibraryForm
			initialValues={settings}
			saveMutation={{
				...editGeneralAgencySettingsOptions,
				invalidateQueryKeys: [getAgencySettingsOptions().queryKey]
			}}
			validationSchema={validationSchema}
			{...MedicareAgencySettingsSection}
		>
			<TextFormField name="name" />
			<TextFormField name="npiNumber" />
			<SelectFormField
				name="agencyStartOfWeek"
				options={DaysOfWeekOptions}
				description="The day of the week when Medicare billing periods start"
			/>
			<AddressFormField name="address" />
			<TextFormField name="cmsCertificationNumber" />
			<TextFormField name="providerOasisSubmissionId" />
		</LibraryForm>
	);
}
